import { makeStyles, } from '@material-ui/core';
import { colorPalette } from '../../colorPalette';
export const useStyles = makeStyles((theme) => ({
    faqItem: {
        width: '100%',
        padding: '0 16px',
        boxSizing: 'border-box',
        marginBottom: '16px',
        cursor: 'pointer'
    },
    btn: {
        width: 'inherit',
        background: `${colorPalette.white}`,
        border: `1px solid ${colorPalette.gray200}`,
        boxSizing: 'border-box',
        borderRadius: '5px',
        padding: '17px 16px',
        textAlign: 'left',
        maxWidth: '832px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    modalContentLink: {
        fontSize: '0.875rem',
        lineHeight: '18px',
        color: `${colorPalette.gray800}`,
    }
}));
